import React, { useState, useEffect, useRef } from 'react';
import { Skeleton, Tooltip, Avatar } from '@mui/material';
import { SortDescNumberIcon, SortAscNumberIcon, SortDescAlphabeticalIcon, SortAscAlphabeticalIcon, ClockIcon } from 'ui-component/custom-icons/icons';

import moment from 'moment';
import { FaSearch} from 'react-icons/fa';
import ExportPopupModal from './modal/ExportPopupModal';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import useIsMobile from 'utils/isMobileUtils';

import DetailModal from '../../../contacts/DetailModal';

// ✅ Clear
const ClientPortalRequestWidgetComponent = ({ details, isLoading }) => {
    const [data, setData] = useState([])
    
    const [sortBy, setSortBy] = useState('date')
    const [sortOrder, setSortOrder] = useState('desc')
            
    const [showExportModal, setShowExportModal] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const [isComponentLoading, setIsComponentLoading] = useState(false);
    const searchTimeout = useRef(null);
    const [showDetailModal, setShowDetailModal] = useState(false);

    const isMobile = useIsMobile();
    const [selectedData, setSelectedData] = useState(null);

    const [initialData, setInitialData] = useState([]) 
    
    


    useEffect(() => {
        if (details) {
            setData(details);
            setInitialData(details);
        }
    }, [details])

    // Debounced search effect
    useEffect(() => {
        setIsComponentLoading(true)
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            if (searchValue) {
                let filtered = initialData;
                if (searchValue) {
                    filtered = filtered.filter(item =>
                        ((item.name || '') + ' ' + (item.company_name || '')).toLowerCase().includes(searchValue.toLowerCase())
                    );
                }

                let sorted = [...filtered];

                if (sortBy === 'name') {
                    sorted.sort((a, b) => {
                        const nameA = a.name || '';
                        const nameB = b.name || '';
                        if (sortOrder === 'asc') {
                            return nameA.localeCompare(nameB);
                        } else {
                            return nameB.localeCompare(nameA);
                        }
                    });
                } else if (sortBy === 'date') {
                    filtered.sort((a, b) => {
                        const dateA = new Date(a.created_at).getTime();
                        const dateB = new Date(b.created_at).getTime();
                        if (sortOrder === 'asc') {
                            return dateA - dateB;
                        } else {
                            return dateB - dateA;
                        }
                    });
                }
                setData(sorted);
            
            } else {

                let filtered = Array.isArray(initialData) ? initialData : [];

                if (sortBy === 'name') {
                    filtered.sort((a, b) => {
                        const nameA = a.company_name || '';
                        const nameB = b.company_name || '';
                        if (sortOrder === 'asc') {
                            return nameA.localeCompare(nameB);
                        } else {
                            return nameB.localeCompare(nameA);
                        }
                    });
                } else if (sortBy === 'date') {
                    filtered.sort((a, b) => {
                        const dateA = new Date(a.created_at).getTime();
                        const dateB = new Date(b.created_at).getTime();
                        if (sortOrder === 'asc') {
                            return dateA - dateB;
                        } else {
                            return dateB - dateA;
                        }
                    });
                }
                setData(filtered);
                // setDatas(details || []);
            }
        setIsComponentLoading(false)
        }, 400); // 400ms debounce
        return () => clearTimeout(searchTimeout.current);
    }, [searchValue, initialData, sortBy, sortOrder]);




    const handleClose = () => {
        setShowExportModal(false);
        setShowDetailModal(false)
        setSelectedData(null);
    }

    return (
        <>
            <div className="card" style={{ height: '594px' }}>
                <div className="card-body" style={{ padding: '15px 5px', zIndex: '1000', zIndex: '1' }}>
                    <div className="flex justify-content-between" style={{ padding: '0 10px' }}>
                        <div className="text-lg fw-500">
                            Client Portal Requests
                        </div>
                        <div className="flex gap-1 absolute" style={{ right: '20px', top: '6px' }}>
                            {
                                isLoading ? (
                                    <div className="" style={{ width: '100px', marginTop: '8px' }}>
                                        <Skeleton variant="rounded" width={'100%'} height={20} className={`rounded-full`} style={{ borderRadius: '32px' }} />
                                    </div>
                                ) : (
                                    <>
                                        <div
                                            className={`widget-action-icon-container-2 ${sortBy === 'name' ? 'active' : '' }`}
                                            onClick={() => {
                                                setSortBy('name')
                                                setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
                                            }}
                                        >
                                            <Tooltip title="Sort by Name" arrow placement="top">

                                                <div
                                                    href="javascript:void(0);" 
                                                    className="widget-action-icon cursor-pointer"
                                                >
                                                    {
                                                        sortBy === 'name' ? (
                                                            sortOrder === 'asc' ? (
                                                                <SortAscAlphabeticalIcon height='15px' width='15px' />
                                                            ) : (
                                                                <SortDescAlphabeticalIcon height='15px' width='15px' />
                                                            )
                                                        ) : (
                                                            <SortDescAlphabeticalIcon height='15px' width='15px' />
                                                        )
                                                    }
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <div
                                            className={`widget-action-icon-container-2 ${sortBy === 'date' ? 'active' : '' }`}
                                            onClick={() => {
                                                setSortBy('date')
                                                setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
                                            }}
                                        >
                                            <Tooltip title="Sort by Date" arrow placement="top">
                                                <div
                                                    href="javascript:void(0);" 
                                                    className="widget-action-icon cursor-pointer"
                                                >

                                                    {
                                                        sortBy === 'name' ? (
                                                            <SortDescNumberIcon height='15px' width='15px' />
                                                        ) : (
                                                            sortOrder === 'asc' ? (
                                                                <SortAscNumberIcon height='15px' width='15px' />
                                                            ) : (
                                                                <SortDescNumberIcon height='15px' width='15px' />
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                        <div className="row" style={{ margin: '10px 0 0 0'}}>

                            <div className="col-12">
                                {
                                    isLoading ? (
                                        <div style={{  width: '100%' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
                                        </div>
                                    ) : (
                                        <div className="flex justify-content-end" style={{ marginBottom: '5px'}}>

                                            <div className="form-inline navbar-search" style={{ width: '100%' }}>
                                                <div style={{ position: 'relative', width: '100%' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control bg-white border"
                                                        placeholder="Search"
                                                        aria-label="Search"
                                                        aria-describedby="basic-addon2"
                                                        value={searchValue}
                                                        onChange={(e) => setSearchValue(e.target.value)}
                                                        style={{
                                                            borderRadius: '32px',
                                                            width: '100%',
                                                        }}
                                                    />
                                                    <span
                                                        className="searchIcon"
                                                        style={{
                                                            position: 'absolute',
                                                            right: 10,
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            color: '#888',
                                                            pointerEvents: 'none'
                                                        }}
                                                    >
                                                        <FaSearch />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    
                    <div className="overflow-y-auto custom-scrollbar" style={{ height: '465px', margin: '10px 0' }}>
                        
                        {
                            isLoading ? (
                                [...Array(25)].map((e, i) => (
                                    <div
                                        key={i}
                                        style={{
                                            padding: '5px'
                                        }}
                                    >
                                        <div className="w-full flex justify-between" style={{ padding: '2px 0' }}>
                                            <div className="flex gap-2 align-items-center">
                                                <div style={{ fontSize: '35px', width: '40px' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={40} style={{ borderRadius: '32px' }} />
                                                </div>
                                                <div>
                                                    <div className="font-14" style={{ width: '150px', marginBottom: '5px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                    <div className="text-gray-600" style={{ width: '100px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex gap-2 ">
                                                <div>
                                                    <div className="text-gray-600" style={{ width: '100px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                isComponentLoading ? (
                                    [...Array(25)].map((e, i) => (
                                        <div
                                            key={i}
                                            style={{
                                                padding: '5px'
                                            }}
                                        >
                                            <div className="w-full flex justify-between" style={{ padding: '2px 0' }}>
                                                <div className="flex gap-2 align-items-center">
                                                    <div style={{ fontSize: '35px', width: '40px' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={40} style={{ borderRadius: '32px' }} />
                                                    </div>
                                                    <div>
                                                        <div className="font-14" style={{ width: '150px', marginBottom: '5px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                        </div>
                                                        <div className="text-gray-600" style={{ width: '100px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex gap-2 ">
                                                    <div>
                                                        <div className="text-gray-600 mb-2" style={{ width: '100px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                        </div>
                                                        <div className="text-gray-600" style={{ width: '100px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    data?.length > 0 ? (
                                        data?.map((item, index) => (
                                            <div
                                                className="dashboard-country-list"
                                                key={item.id || item.name || index}
                                                style={{
                                                    padding: '5px'
                                                }}
                                                onClick={() => {
                                                    setShowDetailModal(true)
                                                    setSelectedData(item);
                                                }}
                                            >
                                                <div className="w-full flex justify-between" style={{ padding: '2px 0' }}>
                                                    <div className="flex gap-3">
                                                        <div className="avatar">
                                                            {
                                                                item?.logo_url ? (
                                                                    <img
                                                                        src={item?.logo_url}
                                                                        style={{
                                                                            height: '40px',
                                                                            width: '40px',
                                                                            borderRadius: '32px',
                                                                            objectFit: 'cover',
                                                                            display: 'block'
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Avatar />
                                                                )
                                                            }
                                                        </div>
                                                        <div>
                                                            <div className="font-normal fw-600">
                                                                {item?.company_name}
                                                            </div>
                                                            <div className="font-normal text-gray-800">
                                                                {item?.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ml-auto">
                                                        <div className=" flex gap-2 text-right italic text-gray-500" style={{ marginRight: '10px', fontSize: '12px', width: '105px' }}>
                                                            <div>
                                                                <ClockIcon height='14px' width='14px' />
                                                            </div>
                                                            <div>
                                                                {moment(item?.created_at).format(CommonDateOnlyFormat)}
                                                            </div>
                                                        </div>
                                                        <div className="font-normal text-gray-800">
                                                            Progress:  { item?.onboarding_progress }%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="row" style={{ padding: '5px 0' }}>
                                            <div className="col-12 text-gray-500 text-center">
                                                No data found        
                                            </div>
                                        </div>
                                    )
                                )    
                            )
                        }


                    </div>
                    <div
                        className="col-12"
                        style={{
                            textAlign: 'center',
                            fontSize: '14px',
                        }}
                    >
                        {
                            isLoading ? (
                                <div style={{ width: '150px', margin: '0 auto' }}>
                                    <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                </div>
                            ) : (
                                data?.length === 0 ? (
                                    'No request found'
                                ) : (
                                    <>
                                        <span className="text-primary fw-500">{ data?.length }</span> requests awaiting to review
                                    </>
                                )
                            )
                        }
                    </div>
                </div>
            </div>
            {
                showExportModal && (
                    <ExportPopupModal
                        isOpen={true}
                        onClose={handleClose}
                        widgetType={'TOP-SUPPLIERS'}
                        widgetName={'Top 10 Suppliers'}
                    />
                )
            }
            {showDetailModal && !isMobile && (
				<DetailModal
					isOpen={showDetailModal}
					onClose={handleClose}
					selectedId={selectedData?.id}
					isApproved={0}
                    onRemove={(client_id) => {
                        setData(prev => prev.filter(item => item.id !== client_id));
                        setInitialData(prev => prev.filter(item => item.id !== client_id));
                        handleClose()
					}}
				/>
            )}
        </>
    )
}


export default ClientPortalRequestWidgetComponent;